import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import {ShoppingCart, Check, Star} from 'lucide-react';

const products = [
  {
    id: 1,
    category: 'Protéines',
    name: 'Isolate HT',
    subtitle: 'BCAA 8.1.1 - Protein Cream',
    description: 'Pureté. Croissance. Gourmand.',
    details: '24g de protéines | 41% d\'acides aminés essentiels EAA | 20% de BCAA',
    weight: '1,8 kg',
    price: 49.90,
    image: 'https://static.lumi.new/e5/e507db8f2fbe415588f4d311f4439e88.webp',
    features: ['Grass Fed', 'Avec Lactase', 'Haute Teneur en Protéines'],
    flavors: ['Protein Cream', 'BCAA 8.1.1 Mangue Passion', 'BCAA 8.1.1 Citron Vert', 'BCAA 8.1.1 Fruits Rouges']
  },
  {
    id: 2,
    category: 'Pre-Workout',
    name: 'Pack Entraînement',
    subtitle: 'Pre Workout - Omega - BCAA 2.1.1',
    description: 'Boost. Intensité. Vitalité.',
    details: '5g de BCAA par dose | Congestion, Énergie et Concentration',
    weight: '300-500g',
    price: 69.90,
    image: 'https://static.lumi.new/92/926af759a421f1aaada55ea76b45242a.webp',
    features: ['Boost Énergie', 'Concentration Maximale', 'Récupération Optimale'],
    flavors: ['Pre Workout Mangue Passion', 'BCAA 2.1.1 Citron', 'BCAA 2.1.1 Fruits Rouges', 'Omega']
  },
  {
    id: 3,
    category: 'Protéines',
    name: 'Native Whey HT',
    subtitle: 'Whey Protéine Premium',
    description: 'Performance. Récupération. Essentiel.',
    details: '76-80% de protéines | Digestion optimale | Saveurs gourmandes',
    weight: '2 kg',
    price: 54.90,
    image: 'https://static.lumi.new/62/627ba326c6f1edea55e1dc5ba4b407ac.webp',
    features: ['Native Whey', 'Haute Digestibilité', 'Sans Artifices'],
    flavors: ['Vanille', 'Chocolat', 'Fraise', 'Neutre']
  },
  {
    id: 4,
    category: 'BCAA',
    name: 'BCAA 8.1.1 HT',
    subtitle: 'Acides Aminés Haute Teneur',
    description: 'Récupération musculaire optimale avec ratio 8:1:1',
    details: '10g de BCAA par dose | Ratio 8:1:1 optimisé | Sans sucres ajoutés',
    weight: '500g',
    price: 34.90,
    image: 'https://static.lumi.new/e5/e507db8f2fbe415588f4d311f4439e88.webp',
    features: ['Ratio 8:1:1', 'Récupération Rapide', 'Anti-Catabolique'],
    flavors: ['Mangue Passion', 'Citron Vert', 'Fruits Rouges']
  },
  {
    id: 5,
    category: 'Pre-Workout',
    name: 'Pre Workout HT',
    subtitle: 'Booster d\'Entraînement',
    description: 'Énergie explosive pour des séances intenses',
    details: 'Caféine | Citrulline | Beta-Alanine | Congestion maximale',
    weight: '300g',
    price: 39.90,
    image: 'https://static.lumi.new/92/926af759a421f1aaada55ea76b45242a.webp',
    features: ['Boost Instantané', 'Focus Mental', 'Endurance Accrue'],
    flavors: ['Mangue Passion', 'Fruit Punch', 'Citron']
  },
  {
    id: 6,
    category: 'Omega 3',
    name: 'Omega 3 EPA/DHA',
    subtitle: 'Acides Gras Essentiels',
    description: 'Santé cardiovasculaire et récupération',
    details: 'Huile de poisson pure | EPA & DHA concentrés | Santé articulaire',
    weight: '90 capsules',
    price: 24.90,
    image: 'https://static.lumi.new/92/926af759a421f1aaada55ea76b45242a.webp',
    features: ['Qualité Epax', 'Sans Métaux Lourds', 'Santé Cardiovasculaire'],
    flavors: ['Nature']
  }
];

const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const categories = ['Tous', 'Protéines', 'BCAA', 'Pre-Workout', 'Omega 3'];

  const filteredProducts = selectedCategory === 'Tous' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://static.lumi.new/e5/e507db8f2fbe415588f4d311f4439e88.webp" 
            alt="Compléments alimentaires" 
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/50" />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-nolimit-red/20 border border-nolimit-red/30 backdrop-blur-sm">
            <span className="text-nolimit-red font-bold tracking-wider text-sm uppercase">Eiyolab Fit - Compléments Premium</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tighter italic">
            NOTRE <span className="text-transparent bg-clip-text bg-gradient-to-r from-nolimit-red to-red-600">BOUTIQUE</span>
          </h1>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed">
            Découvrez notre gamme Eiyolab Fit : protéines, BCAA, pre-workout et compléments pour maximiser vos performances.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-zinc-900 border-b border-white/10 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-4 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-6 py-2 rounded-full font-bold transition-all ${
                  selectedCategory === cat
                    ? 'bg-nolimit-red text-white'
                    : 'bg-black text-gray-400 hover:text-white border border-white/10'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className="bg-zinc-900 rounded-2xl overflow-hidden border border-white/5 hover:border-nolimit-red/50 transition-all group"
              >
                {/* Product Image */}
                <div className="relative h-80 bg-zinc-800 overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-nolimit-red text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                      {product.category}
                    </span>
                  </div>
                </div>

                {/* Product Info */}
                <div className="p-6">
                  <h3 className="text-2xl font-black italic text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-nolimit-red font-bold mb-2">{product.subtitle}</p>
                  <p className="text-gray-400 text-sm mb-4">{product.description}</p>
                  
                  {/* Features */}
                  <div className="mb-4 space-y-2">
                    {product.features.slice(0, 3).map((feature, idx) => (
                      <div key={idx} className="flex items-center text-xs text-gray-300">
                        <Check className="h-4 w-4 text-nolimit-red mr-2" />
                        {feature}
                      </div>
                    ))}
                  </div>

                  {/* Details */}
                  <div className="mb-4 p-3 bg-black rounded-lg border border-white/5">
                    <p className="text-xs text-gray-400">{product.details}</p>
                  </div>

                  {/* Price & CTA */}
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-3xl font-black text-white">{product.price}€</p>
                      <p className="text-xs text-gray-500">{product.weight}</p>
                    </div>
                    <Button className="group-hover:scale-105 transition-transform">
                      <ShoppingCart className="h-4 w-4 mr-2" />
                      Acheter
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-black italic text-white mb-4">
              POURQUOI <span className="text-nolimit-red">EIYOLAB FIT</span> ?
            </h2>
            <p className="text-gray-400">Des compléments de qualité supérieure pour vos objectifs</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: '🏆',
                title: 'Qualité Premium',
                desc: 'Ingrédients sélectionnés avec soin, sans compromis sur la qualité.'
              },
              {
                icon: '🔬',
                title: 'Formules Scientifiques',
                desc: 'Dosages optimaux basés sur les dernières études scientifiques.'
              },
              {
                icon: '✅',
                title: 'Made in France',
                desc: 'Fabriqué en France, contrôles qualité stricts et traçabilité totale.'
              }
            ].map((benefit, idx) => (
              <div key={idx} className="bg-black p-8 rounded-2xl border border-white/5 text-center">
                <div className="text-5xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-bold text-white mb-3">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-nolimit-red relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pattern-grid-lg bg-black" />
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-5xl font-black text-black mb-6 italic uppercase tracking-tighter">
            Besoin de conseils ?
          </h2>
          <p className="text-xl text-white/90 mb-10 font-medium">
            Notre équipe est disponible en salle pour vous conseiller sur les meilleurs compléments adaptés à vos objectifs.
          </p>
          <Button variant="secondary" size="lg" className="bg-white text-nolimit-red hover:bg-gray-100">
            Contactez-nous
          </Button>
        </div>
      </section>
    </Layout>
  );
};

export default Shop;